import { render } from "./ActionLogs.vue?vue&type=template&id=2efee70c&scoped=true"
import script from "./ActionLogs.vue?vue&type=script&lang=js"
export * from "./ActionLogs.vue?vue&type=script&lang=js"

import "./ActionLogs.vue?vue&type=style&index=0&id=2efee70c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2efee70c"]])

export default __exports__